<header-component></header-component>
<main class="main">
    <router-outlet></router-outlet>
</main>
<footer-component></footer-component>